import Material from '@components/common/faq-material'
import { useState } from 'react'

type FAQItem = {
  question: string
  answer: JSX.Element
}

type FAQSection = {
  title: string
  items: FAQItem[]
}

type Props = {
  sections: FAQSection[]
}

const CoursesFAQ = ({ sections }: Props) => {
  const [activeAccordion, setActiveAccordion] = useState('')

  return (
    <div className="bg-white py-16">
      <div className="container mx-auto max-w-4xl px-5 lg:px-0">
        <h2 className="text-3xl lg:text-4xl font-700 mb-12 text-center text-grey-900">
          Frequently Asked Questions
        </h2>

        {sections.map((section, sectionIndex) => (
          <div key={sectionIndex} className="mb-10">
            <h3 className="text-xl font-700 mb-4 text-grey-900">
              {section.title}
            </h3>

            {section.items.map((item, itemIndex) => (
              <Material
                key={`${sectionIndex}-${itemIndex}`}
                title={item.question}
                activeAccordion={activeAccordion}
                setActiveAccordion={setActiveAccordion}
              >
                <div className="text-base pb-4">{item.answer}</div>
              </Material>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default CoursesFAQ
